// extracted by mini-css-extract-plugin
export default {"base":"CopyButton_base__YV8RN","copiedIcon":"CopyButton_copiedIcon__FYd5i","popover":"CopyButton_popover__hLTKn","floatRight":"CopyButton_floatRight__WTCXj"};